import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useInvoice() {
  const createInvoice = async ({ commission, quotation }) => {
    const _body = compress(JSON.stringify({ quotation, commission }));

    const result = await axios.post(`${apiUri}/api/v1/invoices`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data?.data;
  };

  const queryInvoices = async (filter, page, limit, project, sort) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;
    if (sort) reqBody.sort = sort;
    if (project) reqBody.project = project;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/invoices/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const getInvoice = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/invoices/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return result.data?.data;
  };

  const payInvoice = async (id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/invoices/${id}/paid`,
      null,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return result.data;
  };

  return {
    createInvoice,
    queryInvoices,
    getInvoice,
    payInvoice,
  };
}
